import React from 'react';
import { Redirect } from 'react-router-dom';

import Auth from '../../components/Auth';

const Home = () => (
  <Auth>
    {({ authState }) => {
      const userInfo = authState.authenticatedUserInfo || {};
      if (userInfo.type === 'ADMIN') {
        return <Redirect to={{ pathname: '/dashboard' }} />;
      }
      return <Redirect to={{ pathname: '/selection-stage/researchActivity' }} />;
    }}
  </Auth>
);

export default Home;



// WEBPACK FOOTER //
// ./src/pages/Home/Home.js